import { type AxiosResponse } from 'axios';
import { get, post, put } from '@utilities';

export const getAllPayments = async (data: Record<string, any>): Promise<AxiosResponse> => await post('approval/payment/all', data);
export const projectAutocomplete = async (prefix: any): Promise<AxiosResponse> =>
	await get(`project/autocomplete?search_text=${prefix}&limit=10`);
export const fetchPaymentSlip = async (paymentApprovalId: number): Promise<AxiosResponse> =>
	await get(`approval/payment/receipts?approvalId=${paymentApprovalId}`, {});

export const fetchCustomerSlip = async (data: Record<string, any>): Promise<AxiosResponse> => await post(`document/all`, data);

export const approvePayment = async (data: any, paymentApprovalId: number): Promise<AxiosResponse> =>
	await put(`approval/payment/${paymentApprovalId}`, data);

export const createGstInvoice = async (paymentApprovalId: number, data: any): Promise<AxiosResponse> =>
	await post(`approval/payment/${paymentApprovalId}/gst`, data);

export const fetchGstInvoice = async (paymentApprovalId: number): Promise<AxiosResponse> =>
	await get(`approval/payment/${paymentApprovalId}/gst`, {});
